const UPDATE_CURRENT_CHAT = '@@calendar/UPDATE_CURRENT_CHAT';

const UPDATE_CATEGORIES = '@@calendar/UPDATE_CATEGORIES'

const UPDATE_CATEGORY_SCHEDULE = '@@calendar/UPDATE_CATEGORY_SCHEDULE'

const UPDATE_CURRENT_DATE = '@@calendar/UPDATE_CURRENT_DATE'
// const LOG_OUT = '@@auth/CLEAR_SEARCH'

const UPDATE_STAGED_CHANGES = "@@calendar/UPDATE_STAGED_CHANGES"

const RESET_STAGED_CHANGES = '@@calendar/RESET_STAGED_CHANGES'

const UPDATE_TOTH = '@@calendar/UPDATE_TOTH'

const UPDATE_TOTH_FOR_DATE = '@@calendar/UPDATE_TOTH_FOR_DATE'

const UPDATE_SELECTED_DATE = '@@calendar/UPDATE_SELECTED_DATE';


export default {
	UPDATE_CURRENT_CHAT,
	UPDATE_CATEGORIES,
	UPDATE_CATEGORY_SCHEDULE,
	UPDATE_CURRENT_DATE,
	UPDATE_STAGED_CHANGES,
	RESET_STAGED_CHANGES,
	UPDATE_TOTH,
	UPDATE_TOTH_FOR_DATE,
	UPDATE_SELECTED_DATE
	// CLEAR_SEARCH
};